export default {
	methods: {
		cdvAlert(title, message, cb, button) {
			console.log('cdvAlert',title, message, cb, button)
			if (window.navigator.notification
				&& typeof window.navigator.notification.alert === "function"
			) {
				typeof window.navigator.notification.alert(message, cb, title, button)
			} else {
				window.alert([title, message].join(' '))
			}
		},
		cdvConfirm(title, message, cb, buttons) {
			if (window.navigator.notification
				&& typeof window.navigator.notification.confirm === "function"
			) {
				typeof window.navigator.notification.confirm(message, cb, title, buttons)
			} else {
				window.confirm([title, message].join(' '))
			}
		},
		cdvPrompt(title, message, cb, buttons, defaultText) {
			if (window.navigator.notification
				&& typeof window.navigator.notification.prompt === "function"
			) {
				typeof window.navigator.notification.prompt(message, cb, title, buttons, defaultText)
			} else {
				window.prompt([title, message].join(' '), defaultText)
			}
		},
		cdvBeep(times) {
			if (window.navigator.notification
				&& typeof window.navigator.notification.beep === "function"
			) {
				typeof window.navigator.notification.beep(times)
			} else {
				console.log('BEEEEEEP ' + times + ' times')
			}
		}
	}
}
